import { useRef, useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";


import styles from './header.module.css';
import SideMenu from './SideMenu';
import defaultMenu from "../../../config/sideMenuData";
import Breadcrumb from '../Breadcrumb/Breadcrumb';
import ContactInformation from "./ContactInformation";
import { getGradientBackground, getBackgroundColor } from '../../../code/ColorHandler';
import { forceReload } from "../FussballDeWidget/FussballDeWidget";
import { useTheme } from "../../../config/themeContext";
import SettingsModal from "./SettingModal";
import { Icons } from "../../../code/IconHandler";
function Header() {
    const [isSettingsOpen, setIsSettingsOpen] = useState(false);
    const [isContactOpen, setIsContactOpen] = useState(false);
    const [hoveredItem, setHoveredItem] = useState(null);
    const [isMenuOpen, setIsMenuOpen] = useState(false);
    const { isBright, setIsBright } = useTheme();
    const [windowWidth, setWindowWidth] = useState(window.innerWidth);
    const [fontScale, setFontScale] = useState(1); // Default = 100%
    const [customBackground, setCustomBackground] = useState(null);
    const colorInputRef = useRef(null);

    const handlePipetteClick = () => {
        if (colorInputRef.current) {
            colorInputRef.current.click();
        }
    };

    const handleColorChange = (e) => {
        const newColor = e.target.value;
        setCustomBackground(newColor);
        setIsBright(true); // Optional: auto-disable bright mode when custom color is selected
    };
    const MIN_SCALE = 0.7;
    const MAX_SCALE = 1.5;

    const isAtMin = fontScale <= MIN_SCALE;
    const isAtMax = fontScale >= MAX_SCALE;

    useEffect(() => {
        const handleResize = () => setWindowWidth(window.innerWidth);
        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, []);
    const handleInstagramClick = () => {
        window.open("https://www.instagram.com/tus1905oberpleis/", "_blank");
    };
    const handleYoutubeClick = () => {
        window.open("https://www.youtube.com/@tus05oberpleise.v.3", "_blank");
    };
    const handleFacebookClick = () => {
        window.open("https://www.facebook.com/tus05oberpleis/", "_blank");
    };
    const navigate = useNavigate(); // React Router navigation
    const location = useLocation();
    const handleClick = (item) => {
        if (forceReload(item['link'])) {
            window.location.href = item['link'];
        } else {
            navigate(item['link']);
        }
        navigate(item['link']);

    }

    const [submenuPosition, setSubmenuPosition] = useState({});
    const submenuRef = useRef(null);

    // Update submenu position on hover
    useEffect(() => {
        if (hoveredItem && submenuRef.current) {
            const submenuRect = submenuRef.current.getBoundingClientRect();
            const viewportWidth = window.innerWidth;
            // If submenu overflows right edge
            if (submenuRect.right > viewportWidth) {
                // Calculate how much to shift left
                setSubmenuPosition({ right: 0, left: "auto" }); // align right edge of submenu with parent
            } else {
                // Default left align
                setSubmenuPosition({ left: 0, right: "auto" });
            }
        } else {
            // Reset position if no hovered submenu
            setSubmenuPosition({});
        }
    }, [hoveredItem]);

    const onelineMenu = defaultMenu.slice(0, 4);

    useEffect(() => {
        const headerOffset = 120;

        if (location.hash) {
            setTimeout(() => {
                const elementId = location.hash.replace("#", "");
                const targetElement = document.getElementById(elementId);
                if (targetElement) {
                    // Adjust based on your header height
                    const elementPosition = targetElement.getBoundingClientRect().top + window.scrollY;
                    window.scrollTo({
                        top: elementPosition - headerOffset,
                        behavior: "smooth"
                    });
                }
            }, 400); // Delay to ensure DOM is ready
        } else {
            window.scrollTo({
                top: 0,
                behavior: "smooth"
            });
        }
    }, [location]);

    useEffect(() => {
        if (customBackground) {
            document.body.style.background = customBackground;
        } else if (!isBright) {
            document.body.classList.add("dark-mode");
            document.body.style.background = ""; // reset to default dark
            localStorage.setItem("theme", "dark");
        } else {
            document.body.classList.remove("dark-mode");
            document.body.style.background = ""; // reset to default light
            localStorage.setItem("theme", "light");
        }
    }, [isBright, customBackground]);

    useEffect(() => {
        const root = document.documentElement;
        root.style.setProperty('--h1-height', `${1.875 * fontScale}rem`);
        root.style.setProperty('--h2-height', `${1.5625 * fontScale}rem`);
        root.style.setProperty('--h3-height', `${1.25 * fontScale}rem`);
        root.style.setProperty('--default-text', `${1.125 * fontScale}rem`);
        root.style.setProperty('--default-text-tablet', `${0.9375 * fontScale}rem`);
        root.style.setProperty('--small-text', `${0.75 * fontScale}rem`);
    }, [fontScale]);

    const increaseFontScale = () => {
        setFontScale(prev => Math.min(prev + 0.1, 1.5)); // Limit to 150%
    };

    const decreaseFontScale = () => {
        setFontScale(prev => Math.max(prev - 0.1, 0.7)); // Limit to 75%
    };

    useEffect(() => {
        const savedScale = localStorage.getItem('fontScale');
        if (savedScale) {
            setFontScale(parseFloat(savedScale));
        }

        const savedColor = localStorage.getItem('customBackground');
        if (savedColor) {
            setCustomBackground(savedColor);
        }
    }, []);
    useEffect(() => {
        localStorage.setItem('fontScale', fontScale);
    }, [fontScale]);
    useEffect(() => {
        if (customBackground) {
            localStorage.setItem('customBackground', customBackground);
        } else {
            localStorage.removeItem('customBackground'); // Cleanup if reset
        }
    }, [customBackground]);
    return (
        <header>
            <div className={styles.headerWrapper}>
                <SideMenu isMenuOpen={isMenuOpen} setIsMenuOpen={setIsMenuOpen} />
                <ContactInformation isContactOpen={isContactOpen} setIsContactOpen={setIsContactOpen} />

                {hoveredItem && <div className={styles.overlay}></div>}
                <div className={styles.header}>
                    <div className={styles.spacer}>
                        <div className={styles.social}>

                            <img
                                tabIndex={0}
                                src={`/assets/icons/instagram.png`}
                                alt="Instagram"
                                onClick={handleInstagramClick}
                                onKeyDown={(e) => {
                                    if (e.key === "Enter" || e.key === " ") {
                                        e.preventDefault(); // Prevent space from scrolling
                                        handleInstagramClick();
                                    }
                                }}
                                style={{ cursor: "pointer" }} />
                            <img
                                tabIndex={0}
                                src={`/assets/icons/youtube.png`}
                                alt="Youtube"
                                onClick={handleYoutubeClick}
                                onKeyDown={(e) => {
                                    if (e.key === "Enter" || e.key === " ") {
                                        e.preventDefault(); // Prevent space from scrolling
                                        handleYoutubeClick();
                                    }
                                }}
                                style={{ cursor: "pointer" }} />
                            <img
                                tabIndex={0}
                                src={`/assets/icons/facebook.png`}
                                alt="Facebook"
                                onClick={handleFacebookClick}
                                onKeyDown={(e) => {
                                    if (e.key === "Enter" || e.key === " ") {
                                        e.preventDefault(); // Prevent space from scrolling
                                        handleFacebookClick();
                                    }
                                }}
                                style={{ cursor: "pointer" }} />
                            <Icons.Info

                                onClick={() => setIsContactOpen(true)}
                                onKeyDown={(e) => {
                                    if (e.key === "Enter" || e.key === " ") {
                                        e.preventDefault(); // Prevent space from scrolling
                                        setIsContactOpen(true);
                                    }
                                }}
                                style={{
                                    cursor: "pointer",
                                    color: isBright ? "black" : "white",

                                }}
                            />
                            <svg tabIndex={0} xmlns="http://www.w3.org/2000/svg" shapeRendering="geometricPrecision" textRendering="geometricPrecision" imageRendering="optimizeQuality" fillRule="evenodd" clipRule="evenodd" viewBox="0 0 450 511.99" onClick={() => setIsSettingsOpen(true)}
                                onKeyDown={(e) => {
                                    if (e.key === "Enter" || e.key === " ") {
                                        e.preventDefault();
                                        setIsSettingsOpen(true);
                                    }
                                }}
                                style={{
                                    cursor: "pointer",
                                    fill: isBright ? "black" : "white",

                                }}
                                alt="Settings-Icon"
                            >
                                <path d="m307.28 396.06-.09 15.75c-.04 7.37-6.06 13.36-13.41 13.34l-14.62-.07c-2.17 7.14-5.24 13.89-9.14 20.08l10.77 10.88c5.19 5.24 5.16 13.75-.05 18.94l-11.18 11.1c-5.26 5.17-13.77 5.14-18.96-.1L239 474.29a83.026 83.026 0 0 1-19.32 7.57l-.09 16.81c-.03 7.35-6.07 13.36-13.45 13.32l-15.74-.06c-7.35-.02-13.36-6.09-13.32-13.45l.06-16.96a84.247 84.247 0 0 1-19.08-7.8l-11.91 11.81c-5.2 5.19-13.72 5.16-18.91-.08l-11.09-11.2c-5.19-5.21-5.16-13.72.06-18.91l11.28-11.15a83.952 83.952 0 0 1-8.8-19.79l-15.15-.07c-7.37-.03-13.38-6.1-13.34-13.45l.08-15.74c.04-7.38 6.07-13.39 13.42-13.35l13.73.06a82.18 82.18 0 0 1 8.36-21.77l-9.11-9.18c-5.19-5.21-5.15-13.76.07-18.95l11.18-11.06c5.25-5.19 13.75-5.16 18.94.07l8.3 8.38c6.95-4.31 14.59-7.57 22.66-9.7l.06-11.39c.03-7.35 6.09-13.34 13.44-13.31l15.75.07c7.36.02 13.36 6.08 13.33 13.44l-.04 11.21c8.14 2.13 15.81 5.5 22.79 9.83l8.17-8.1c5.21-5.15 13.72-5.12 18.91.1l11.08 11.18c5.19 5.22 5.16 13.77-.05 18.94l-8.83 8.72c3.8 6.87 6.65 14.35 8.38 22.24l13.11.06c7.38.04 13.39 6.06 13.35 13.43zM145.58 86.79c31.46.98 56.18 27.28 55.18 58.79-.96 31.46-27.28 56.18-58.77 55.22-31.46-1-56.19-27.32-55.2-58.81.98-31.46 27.28-56.2 58.79-55.2zm96.28 316.88c-.1 23.79-19.51 43.04-43.3 42.9-23.84-.1-43.06-19.47-42.94-43.27.09-23.84 19.51-43.04 43.3-42.94 23.83.09 43.05 19.48 42.94 43.31zm112.82-175.21c19.22-3.55 37.65 9.13 41.21 28.35 3.57 19.2-9.15 37.65-28.35 41.24-19.22 3.54-37.66-9.15-41.21-28.36-3.54-19.22 9.15-37.69 28.35-41.23zM137.87.01l20.82.67c9.71.31 17.44 8.51 17.12 18.25l-.59 19.26c9.36 3.14 18.16 7.48 26.21 12.85l14.79-13.88c7.1-6.67 18.36-6.32 25.01.78l14.27 15.18c6.69 7.09 6.31 18.38-.78 25.04l-15.87 14.9c4.11 8.1 7.29 16.77 9.33 25.85l22.21.7c9.75.3 17.45 8.51 17.17 18.26l-.67 20.82c-.31 9.71-8.51 17.44-18.26 17.12l-22.44-.68c-2.63 8.82-6.34 17.18-10.96 24.92l15.18 16.17c6.66 7.1 6.32 18.36-.78 25.01l-15.18 14.27c-7.1 6.66-18.38 6.31-25.05-.78l-14.33-15.27c-8.23 4.71-17.11 8.42-26.48 10.9l-.63 20.04c-.31 9.75-8.51 17.45-18.26 17.17l-20.79-.67c-9.75-.31-17.47-8.51-17.17-18.26l.58-18.1a110.615 110.615 0 0 1-28.51-11.84l-12.47 11.72c-7.07 6.66-18.35 6.32-25.02-.78l-14.25-15.18c-6.66-7.1-6.32-18.35.78-25.05l11.37-10.68a108.9 108.9 0 0 1-12-30.29l-15.06-.47C7.43 167.65-.27 159.45.01 149.7l.67-20.83c.31-9.71 8.51-17.43 18.25-17.13l14.83.48c3.11-10.71 7.8-20.74 13.79-29.82L37.16 71.34c-6.67-7.07-6.32-18.35.78-25.02l15.18-14.25c7.09-6.66 18.35-6.32 25.04.78l11.21 11.94c9.24-4.77 19.21-8.27 29.7-10.28l.54-17.35c.3-9.73 8.51-17.43 18.26-17.15zm200.67 176.87 12.74-2.35c5.94-1.1 11.68 2.86 12.78 8.8l2.17 11.78c6.09.66 12 2.13 17.6 4.31l7.12-10.38c3.43-4.96 10.28-6.22 15.27-2.8l10.66 7.32c4.96 3.43 6.22 10.28 2.83 15.27l-7.67 11.13c3.58 4.37 6.64 9.21 9.05 14.42l13.57-2.51c5.94-1.1 11.7 2.89 12.8 8.83l2.36 12.69c1.09 5.94-2.86 11.69-8.8 12.79l-13.71 2.55a67.108 67.108 0 0 1-3.36 16.55l11.35 7.8c4.96 3.43 6.25 10.31 2.82 15.27l-7.32 10.66c-3.42 4.96-10.31 6.24-15.27 2.83l-10.72-7.37c-4.36 3.94-9.27 7.32-14.61 10.1l2.27 12.22c1.09 5.94-2.87 11.73-8.8 12.81l-12.73 2.36c-5.9 1.1-11.69-2.86-12.79-8.83l-2.03-11.03a67.976 67.976 0 0 1-18.83-3.42l-6.02 8.73c-3.41 5-10.28 6.25-15.28 2.84l-10.65-7.32c-4.97-3.44-6.26-10.28-2.83-15.28l5.49-7.97a68.21 68.21 0 0 1-11.28-16.78l-9.16 1.69c-5.94 1.1-11.7-2.86-12.8-8.8l-2.36-12.69c-1.09-5.94 2.86-11.72 8.8-12.82l9.05-1.67c.47-6.88 2.01-13.57 4.43-19.86l-7.76-5.34c-4.97-3.42-6.25-10.31-2.82-15.27l7.32-10.64c3.42-5.01 10.31-6.26 15.27-2.84l8.38 5.75c4.97-4.09 10.56-7.55 16.63-10.15l-1.96-10.56c-1.1-5.97 2.86-11.71 8.8-12.82z" /></svg>
                            {isSettingsOpen && (
                                <SettingsModal
                                    onClose={() => setIsSettingsOpen(false)}
                                    isBright={isBright}
                                    setIsBright={setIsBright}
                                    isAtMin={isAtMin}
                                    isAtMax={isAtMax}
                                    increaseFontScale={increaseFontScale}
                                    decreaseFontScale={decreaseFontScale}
                                    handlePipetteClick={handlePipetteClick}
                                    handleColorChange={handleColorChange}
                                    colorInputRef={colorInputRef}
                                    setCustomBackground={setCustomBackground}
                                    setFontScale={setFontScale}
                                />
                            )}
                        </div>
                    </div>
                    <div className={styles.menueline} style={{ background: getGradientBackground(location, isBright) }}>
                        <div
                            className={styles.menubutton} >
                            <svg
                                tabIndex={0}
                                onClick={() => setIsMenuOpen(true)}
                                onKeyDown={(e) => {
                                    if (e.key === "Enter" || e.key === " ") {
                                        e.preventDefault(); // Prevent space from scrolling
                                        setIsMenuOpen(true);
                                    }
                                }}


                                version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 122.88 95.95" ><g><path d="M8.94,0h105c4.92,0,8.94,4.02,8.94,8.94l0,0c0,4.92-4.02,8.94-8.94,8.94h-105C4.02,17.88,0,13.86,0,8.94l0,0 C0,4.02,4.02,0,8.94,0L8.94,0z M8.94,78.07h105c4.92,0,8.94,4.02,8.94,8.94l0,0c0,4.92-4.02,8.94-8.94,8.94h-105 C4.02,95.95,0,91.93,0,87.01l0,0C0,82.09,4.02,78.07,8.94,78.07L8.94,78.07z M8.94,39.03h105c4.92,0,8.94,4.02,8.94,8.94l0,0 c0,4.92-4.02,8.94-8.94,8.94h-105C4.02,56.91,0,52.89,0,47.97l0,0C0,43.06,4.02,39.03,8.94,39.03L8.94,39.03z" /></g></svg>
                        </div>
                        <div
                            className={styles.tuslogo}>
                            <img
                                tabIndex={0}
                                src={`/images/logo.png`}
                                alt="TuS05-Logo"
                                onClick={() => handleClick({ link: "/" })}
                                onKeyDown={(e) => {
                                    if (e.key === "Enter" || e.key === " ") {
                                        e.preventDefault(); // Prevent space from scrolling
                                        handleClick({ link: "/" })
                                    }
                                }}
                                style={{ cursor: "pointer" }} />
                            <p>Menü</p>
                        </div>
                        <div className={styles.menuitems}>
                            {onelineMenu.map((item) => (
                                <div
                                    tabIndex={0}
                                    key={item['name']}
                                    className={styles.menuItemWrapper}
                                    onMouseEnter={() => setHoveredItem(item)}
                                    onMouseLeave={() => setHoveredItem(null)}
                                    onKeyDown={(e) => {
                                        if (e.key === "Enter" || e.key === " ") {
                                            e.preventDefault(); // Prevent space from scrolling
                                            if (hoveredItem === null) {
                                                setHoveredItem(item)
                                            } else {
                                                setHoveredItem(null)
                                            }
                                        }
                                    }}
                                >
                                    <p
                                        tabIndex={0}
                                        className={`${styles.paragraph} ${hoveredItem === item ? styles.bold : ""}`} onClick={() => handleClick(item)}
                                        onKeyDown={(e) => {
                                            if (e.key === "Enter" || e.key === " ") {
                                                e.preventDefault(); // Prevent space from scrolling
                                                handleClick(item)
                                            }
                                        }}
                                        style={{ cursor: "pointer" }}>
                                        {windowWidth <= 950 && item.short ? item.short : item.name}
                                    </p>

                                    {/* Submenu that appears when hovering */}
                                    {hoveredItem === item && (
                                        <div
                                            ref={submenuRef}
                                            className={styles.submenu}
                                            onMouseEnter={() => setHoveredItem(item)}
                                            onMouseLeave={() => setHoveredItem(null)}
                                            style={submenuPosition}
                                        >
                                            {item['subcontent'].map((subItem) => (
                                                <p key={subItem['name']} className={styles.submenuItem}
                                                    tabIndex={0}
                                                    onClick={() => handleClick(subItem)}
                                                    onKeyDown={(e) => {
                                                        if (e.key === "Enter" || e.key === " ") {
                                                            e.preventDefault(); // Prevent space from scrolling
                                                            handleClick(subItem)
                                                        }
                                                    }}
                                                    onMouseEnter={(e) => e.target.style.setProperty('--dynamic-bg-color', getBackgroundColor(location))}
                                                    onMouseLeave={(e) => e.target.style.removeProperty('--dynamic-bg-color')}
                                                >
                                                    {subItem['name']}
                                                </p>
                                            ))}
                                        </div>
                                    )}
                                </div>
                            ))}
                        </div>
                    </div>
                    <Breadcrumb className={styles.breadcrumb}></Breadcrumb>
                </div>

            </div>
        </header>
    )
}

export default Header;